import React, { FC } from 'react';
import {
	VictoryChart,
	VictoryAxis,
	VictoryStack,
	VictoryBar,
	VictoryLabel,
	VictoryTooltip,
} from 'victory';

import { fontFamily } from '../../../../assets/themes';
import colors from '../../../../assets/colors';
import { formatToCurrency, kFormatter } from '../../../../core/helpers/numberFormatter';
import useWindowSize from '../../../../core/hooks/useWindowSize';

export const barColors = [
	'#FFC700',
	'#FF5017',
	'#180B66',
	'#4AC5EC',
	'#D57EFF',
	'#0038FF',
	'#1DEA57',
	'#C24AEC',
	'#FF00B8',
	'#7EE8FF',
	'#8A1DEA',
	'#FF0039',
	'#00FF07',
	'#288DFF',
	'#FFDC53',
	'#00FFC6',
	'#EA1DE3',
	'#F7FF00',
	'#FF0078',
	'#FF8700',
];
const maxlimit = 12;
const DEFAULT_SNAPS_NAMES = [
	'top20CustomersByTotalBookingAmount',
	'currentQuarterPipelineByStageAndOwner',
	'Top 20 customers by total booking amount',
	'Current quarter pipeline by stage and owner',
];

const Chart: FC<any> = ({ chartWidth, chartData, finalData, name }) => {
	const { height, width } = useWindowSize();
	const chartHeight = height / 2.2;
	return (
		<VictoryChart
			domainPadding={{ x: 120, y: 20 }}
			padding={{
				top: 30,
				bottom: 56,
				left: 0,
				right: -20,
			}}
			{...(width > 1024 ? { height: chartHeight } : null)}
			width={chartWidth + 24}
		>
			<VictoryAxis
				dependentAxis
				tickFormat={t => ``}
				style={{
					axis: { stroke: 'transparent' },
					grid: {
						stroke: colors.border,
						strokeWidth: 1,
						strokeDasharray: 0,
					},
				}}
			/>
			<VictoryStack colorScale={barColors}>
				{finalData.map((bar: any, i: number) => (
					<VictoryBar
						key={i}
						data={chartData[bar]}
						x="_id"
						y={(datum) =>
							DEFAULT_SNAPS_NAMES.includes(name)
								? datum.count
								: datum.count
						}
						barWidth={50}
						style={{
							data: {
								fill: d => d.datum.color,
							},
						}}
						labelComponent={
							<VictoryTooltip
								dy={10}
								dx={20}
								style={{
									fontSize: 12,
									fill: '#fff',
									fontWeight: 600,
									fontFamily: fontFamily.primaryRegular,
								}}
								cornerRadius={5}
								orientation="right"
								flyoutHeight={18}
								flyoutPadding={13}
								pointerLength={4}
								flyoutStyle={{ fill: '#000' }}
								renderInPortal={true}
							/>
						}
						labels={({ datum }) =>
							DEFAULT_SNAPS_NAMES.includes(name)
								? `${bar} ${formatToCurrency(+datum.count)}`
								: `${bar} ${kFormatter(datum.count, true)}`
						}
					/>
				))}
			</VictoryStack>
			<VictoryAxis
				dependentAxis
				tickFormat={t =>
					DEFAULT_SNAPS_NAMES.includes(name)
						? formatToCurrency(+t)
						: kFormatter(t.toString(), true)
				}
				tickLabelComponent={
					<VictoryLabel dy={-14} dx={30} textAnchor="start" />
				}
				style={{
					axis: { stroke: 'transparent', strokeWidth: 2 },
					tickLabels: {
						fontFamily: fontFamily.primaryRegular,
						fontSize: 12,
					},
				}}
			/>
			<VictoryAxis
				tickFormat={t =>
					t
						.toString()
						.split(' ')
						.map((el: string) =>
							el.length > maxlimit ? el.substring(0, maxlimit - 1) + '...' : el
						)
				}
				style={{
					axis: { stroke: colors.grey },
					tickLabels: {
						fontFamily: fontFamily.primaryRegular,
						fontWeight: 700,
						fontSize: 14,
					},
				}}
			/>
		</VictoryChart>
	);
};

export default React.memo(Chart);
